import { useNavigate } from "react-router-dom";
import { Link } from "../../molecules/Link";
import { useDispatch } from "react-redux";
import { cerrarSesion } from "../../../store/slices/usuario.slice";
import { UsuarioMenu } from "../../molecules/UsuarioMenu";

export const EstudianteNavbar = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(cerrarSesion());
    navigate("/");
  };

  return (
    // <div className={"relative flex flex-col md:flex-row bg-theme-blue p-3"}>
    //   <nav className={"flex text-white flex-grow"}>
    <div className="relative flex flex-row bg-theme-blue p-3">
      <nav className="flex text-white flex-grow">
        <Link route={"/inicio"} underline={true} end={false}>
          {"Inicio"}
        </Link>
        <Link route={"/perfilEstudiante"} underline={true} end={false}>
          {"Perfil"}
        </Link>
      </nav>
      {/* <div className={"flex items-center md:ml-4 mt-4 md:mt-0"}>
        <button
          className="bg-white bg-opacity-50 rounded-md px-3 py-2 text-white my-auto"
          onClick={handleLogout}
        >
          Cerrar sesión
        </button>
      </div> */}
      <UsuarioMenu />
    </div>
  );
};
